
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/atlas",
      function () {
        return require("private-next-pages/docs/atlas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/atlas"])
      });
    }
  